module.exports = __webpack_public_path__ + "static/media/dashboard-icon.fc2f0b64.svg";